import { useState, useEffect } from 'react';
import { Save } from "lucide-react";
import Select from "react-select";
import axios from 'axios';

const CreateSubjectModal = ({ onClose }) => {
    // State to hold form data
    const [formData, setFormData] = useState({
        name: '',
        hours: '',
        previousSubject: '',
        description: '',
        course_ids: [],
        group_codes: [],
        lecturer_ids: []
    });
    // State to hold selects
    const [selects, setSelects] = useState({
        courses: [],
        groups: [],
        lecturers: [],
        modules: []
    });

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/courses/formData`)
        .then(res => setSelects(res.data));
    }, []);

    const handleSubmit = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/courses/createSubject`, formData);
            onClose();
        } catch (err) {
             console.error("Error creating subject:", err);
        }
    };

    return (
        <div className="module-modal-overlay">
            <div className="module-modal-content">
                <h3 className="modal-title">Utwórz nowy przedmiot</h3>
                <div className="form-group">
                    <label>Nazwa Przedmiotu </label>
                    <input
                        type="text"
                        placeholder="Wprowadź nazwę przedmiotu"
                        className='form-input'
                        value={formData.name}
                        onChange={(e) => setFormData({
                            ...formData,
                            name: e.target.value
                        })}
                    />
                </div>
                <div className="form-group">
                    <label>Liczba godzin </label>
                    <input
                        type="number"
                        placeholder="Wprowadź liczbę godzin"
                        className='form-input'
                        value={formData.hours}
                        onChange={(e) => setFormData({
                            ...formData,
                            hours: e.target.value
                        })}
                    />
                </div>
                <div className="form-group">
                    <label>Przedmiot poprzedzający (opcjonalne)</label>
                    <Select
                        options={selects.modules.map(m => ({
                            value: m.module_id,
                            label: m.module_name
                        }))}
                        onChange={(selected) => {
                            setFormData({
                                ...formData,
                                previousSubject: selected ? selected.value : '',
                            });
                        }}
                        placeholder="Wybierz przedmiot poprzedzający"
                        className='form-select'
                    >
                    </Select>
                </div>
                <div className="form-group">
                    <label>Opis (opcjonalne)</label>
                    <textarea
                        placeholder="Wprowadź opis przedmiotu"
                        className='form-input'
                        value={formData.description}
                        onChange={(e) => setFormData({
                            ...formData,
                            description: e.target.value
                        })}
                    />
                </div>
                <div className="form-group">
                    <label>Kurs</label>
                    <Select
                        isMulti
                        name='courses_ids'
                        options={selects.courses.map(c => ({
                            value: c.course_id,
                            label: [
                                c.course_name,
                                c.academic_year
                            ].filter(Boolean).join(' '),
                        }))}
                        onChange={(selected) => {
                            setFormData({
                                ...formData,
                                course_ids: selected ? selected.map(s => s.value) : [],
                            });
                        }}
                        placeholder="Wybierz kurs/kursy"
                        className='form-select'
                    >
                    </Select>
                </div>
                <div className="form-group">
                    <label>Grupy</label>
                    <Select
                     isMulti
                     name='group_codes'
                     options={selects.groups.map(g => ({
                         value: g.group_code,
                         label: [
                            g.group_name
                        ].filter(Boolean).join(' - '),
                     }))}
                     onChange={(selected) => {
                         setFormData({
                             ...formData,
                             group_codes: selected ? selected.map(s => s.value) : [],
                         });
                     }}
                     placeholder="Wybierz grupę/grupy"
                     className='form-select'
                    >
                    </Select>
                </div>
                <div className="form-group">
                    <label>Wykładowcy</label>
                    <Select
                        isMulti
                        name='lecturer_ids'
                        options={selects.lecturers.map(l => ({
                            value: l.lecturer_id,
                            label: [
                                l.academic_position ? l.academic_position + "." : null,
                                l.first_name,
                                l.last_name
                            ].filter(Boolean).join(' '),
                        }))}
                        onChange={(selected) => {
                            setFormData({
                                ...formData,
                                lecturer_ids: selected ? selected.map(s => s.value) : [],
                            });
                        }}
                        placeholder="Wybierz wykładowcę/wykładowców"
                        className='form-select'
                    >
                    </Select>
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="button-secondary">Anuluj</button>
                    <button onClick={handleSubmit} className="button-primary">
                        <Save size={16} />
                        Zapisz
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateSubjectModal;